import React from "react";

import {LoadingView} from "../../../../designSystem/components/LoadingView";
import {Typography} from "../../../../designSystem/components/Typography";
import {MeasurementChart} from "../../../../components/MeasurementChart";
import {MeasurementTable} from "../../../../components/MeasurementTable";
import {StandardLayout} from "../../../../components/StandardLayout";

import {
  useExportMeasurement,
  useMeasurementListView,
  useMeasurementManagementData,
  useMeasurementManagementState,
} from "../../hooks";
import {GuestSelectorPanel} from "../GuestSelectorPanel";
import {MetricSelector} from "../MetricSelector";

export const MeasurementManagementFeature = ({ userToken }) => {
  const {measurements, guests, loading} = useMeasurementManagementData({userToken});
  const {
    selectedGuestId,
    selectedGuestName,
    selectedMetric,
    search,
    setSearch,
    onPressMetric,
    onSelectGuest,
  } = useMeasurementManagementState();
  const {filteredGuests, filteredMeasurements} = useMeasurementListView({
    guests,
    measurements,
    search,
    selectedMetric,
    selectedGuestId,
  });

  const { exportData } = useExportMeasurement({ measurements, guests })
  return (
    <StandardLayout
      headerTitle="生理量測紀錄系統"
      headerActionLabel="匯出資料"
      headerActionIcon="fa-file-export"
      headerActionOnClick={exportData}
      body={
        <React.Fragment>
          {loading ? (
            <LoadingView />
          ) : (
            <div className="flex h-full">
              <GuestSelectorPanel
                search={search}
                onChangeSearch={setSearch}
                filteredGuests={filteredGuests}
                selectedGuestId={selectedGuestId}
                onSelectGuest={onSelectGuest}
              />

              <div className="flex-1 p-6 pt-0">
                {selectedGuestId
                  ?
                  <div className="flex flex-col gap-4">
                    <Typography variant="subtitle">
                      {selectedGuestName} 的生理量測數據
                    </Typography>
                    <MetricSelector selectedMetric={selectedMetric} onPressMetric={onPressMetric} />

                    {filteredMeasurements?.length > 0 ? (
                      <>
                        <MeasurementChart
                          measurements={filteredMeasurements}
                          metricType={selectedMetric}
                        />
                        <div className="px-2 pb-2">
                          <MeasurementTable
                            measurements={filteredMeasurements}
                            metricType={selectedMetric}
                          />
                        </div>
                      </>
                    ) : (
                      <Typography variant="captionMuted" className="text-center">
                        暫無錄得數據
                      </Typography>
                    )}
                  </div>
                  : (
                    <Typography variant="subtitle">
                      請先從左邊列表選擇使用者
                    </Typography>
                  )
                }
              </div>
            </div>
          )}
        </React.Fragment>
      }
    />
  )
}
